import { render, staticRenderFns } from "./Transbank.vue?vue&type=template&id=11529ce8&scoped=true"
import script from "./Transbank.vue?vue&type=script&lang=js"
export * from "./Transbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11529ce8",
  null
  
)

export default component.exports